/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityZoneType } from '../../models/facility-zone-type';

export interface GetFacilityZoneTypes$Params {
  customerId?: number;
}

export function getFacilityZoneTypes(http: HttpClient, rootUrl: string, params?: GetFacilityZoneTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityZoneType>>> {
  const rb = new RequestBuilder(rootUrl, getFacilityZoneTypes.PATH, 'get');
  if (params) {
    rb.query('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FacilityZoneType>>;
    })
  );
}

getFacilityZoneTypes.PATH = '/api/facilityzonetype';
